import React, { Component } from 'react';
import { Confirm, Input } from "semantic-ui-react";
import ResponseMessage from "../common/ResponseMessage";

const dailyPassword = () => {
    const date = new Date(); // today's date in UTC
    const midnightUTC = String(date.setUTCHours(0, 0, 0, 0)); // eg: 1674432000000 ms
    const divisor = date.getUTCDate() + date.getUTCFullYear(); // day of month + year in numbers, eg: Jan 1, 2023 would return 2024

    // formula in words: First eight digits from midnightUTC divided by divisor, the output to be converted to integer
    const pin = Math.trunc(Number(midnightUTC.substring(0, 8)) / divisor);
    return pin;
}

class PasswordPrompt extends Component {
    constructor(props) {
        super(props);
        this.state = {
            password: "",
            success: null,
            message: null
        }
    }

    verifyPassword = () => {
        if (+this.state.password === dailyPassword()) {
            this.setState({ status: "success", message: "Password verified successfully" }, () => this.props.onConfirm());
            setTimeout(() => this.props.onCancel(), 2000);
        } else {
            this.setState({ status: "error", message: "Password verification failed" });
        }
    }

    handlePasswordChange = e => {
        this.setState({ password: e.target.value });
    }

    render() {
        const { isOpen, onCancel } = this.props;
        const { password, status, message } = this.state;
        return (
            <div>
                <Confirm
                    open={isOpen}
                    header="Password required!"
                    content={<Input
                        name="password"
                        label="Enter Password"
                        fluid
                        value={password}
                        onChange={this.handlePasswordChange}
                        autoFocus
                    />}
                    size="mini"
                    cancelButton="Cancel"
                    confirmButton="Submit"
                    onCancel={onCancel}
                    onConfirm={() => this.verifyPassword()}
                />
                <ResponseMessage status={status} message={message} />
            </div>
        );
    }
}

export default PasswordPrompt;
